import { render } from "./WalkthroughView.vue?vue&type=template&id=0f00e38e&scoped=true&ts=true"
import script from "./WalkthroughView.vue?vue&type=script&lang=ts"
export * from "./WalkthroughView.vue?vue&type=script&lang=ts"

import "./WalkthroughView.scss?vue&type=style&index=0&id=0f00e38e&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f00e38e"]])

export default __exports__